<template>
  <Layout>
    <div class="mc-list-header">
      <PageHeader :title="title" :subTitle="$t('trackingTemp.description')" />
    </div>

    <McGrapqlTable
      ref="mc-table-tracking-temp"
      :key="tableKey"
      trackBy="temporaryLvId"
      withCard
      searchable
      stickyHeader
      hasCheckbox
      isTextWrap
      singleSort
      hasFilter
      :hasDisabled="true"
      :hasSelectAll="false"
      :apiClient="trackingTemporaryListApiClient"
      :activeFilters="activeFilters"
      :fields="fields"
      :customHandlers="customHandlers"
    >
      <!-- TODO: For future enhancement -->
      <!-- <template #button-filter>
        <McInlineFilter
          :filterItems="inlineFilterItems"
          :activeKeys="activeFilters['status']"
          @update:activeKeys="handleChangeActiveFilters([{ key: 'status', values: $event }])"
        />
      </template> -->

      <template #head(shareBtn)="{ label }">
        <div class="text-center">
          {{ label }}
        </div>
      </template>

      <template #cell(createdOn)="{ item }">
        <div>
          {{ formatIndexDate(item.createdOn).date }}
        </div>
        <div class="mc-datetime">
          {{ formatIndexDate(item.createdOn).time }}
        </div>
      </template>

      <template #cell(expiresOn)="{ item }">
        <div>
          {{ formatIndexDate(item.expiresOn).date }}
        </div>
        <div class="mc-datetime">
          {{ formatIndexDate(item.expiresOn).time }}
        </div>
      </template>

      <!-- TODO: For future enhancement -->
      <!-- <template #cell(vehicledIds)="{ value, item }">
        <div>
          <p :id="`popover-license-plate-${item.temporaryLvId}`">
            {{ value[0].licensePlate }} {{ value.length > 1 ?? `(+${value.length - 1})` }}
          </p>
          <b-tooltip
            triggers="hover"
            placement="bottom"
            :target="`popover-license-plate-${item.temporaryLvId}`"
          >
            <div v-for="vehicle in value" :key="vehicle.vehicleId">
              {{ vehicle.licensePlate }}
            </div>
          </b-tooltip>
        </div>
      </template> -->

      <template #cell(status)="{ item }">
        <span v-if="item.status === 'A'" class="mc-status mc-status--green">
          {{ $t('global.active') }}
        </span>
        <span v-else-if="item.status === 'E'" class="mc-status mc-status--grey">
          {{ $t('global.nonActive') }}
        </span>
      </template>

      <template #cell(shareBtn)="{ item }">
        <div class="text-center">
          <McButton
            size="sm"
            variant="secondary"
            icon="icon-outline_share"
            :text="$t('trackingTemp.share')"
            @click="() => handleOpenShareModal(item)"
          />
        </div>
      </template>
    </McGrapqlTable>

    <ModalShareActions
      :link="selectedItemLink"
      :title="modalShareTitle"
    />

    <ModalContactForm
      ref="modal-contact-form"
      isShowCopyLink
      cancelTitle="Tutup"
      confirmTitle="Kirim"
      :link="selectedItemLink"
      :title="modalShareTitle"
      :isLoading="isSubmitContact"
      @cancel="handleCancelModalCreateContact"
      @create:contact="handleAddContact"
    />
  </Layout>
</template>

<script>
import appConfig from '@/app.config'
import { MixPanel } from '@/mixin/mixpanel'

import PageHeader from '@/components/page-header-v2'
import Layout from '@/router/layouts/main'
import McGrapqlTable from '@/components/McGrapqlTable'
// import McInlineFilter from '@/components/McInlineFilter'
import McButton from '@/components/McButton'
import ModalContactForm from './components/modals/ModalContactForm'
import ModalShareActions from './components/modals/ModalShareActions'

import {
  DELETE_TRACKING_TEMPORARY,
  TRACKING_TEMPORARY_LIST,
  UPSERT_CONTACT_LOCATION_TEMPORARY,
} from '@/services/api/trackingTemporary/temporary'

import { fields } from './lib/fields/list-temporary-tracking-fields'
import inlineFilterItems from './lib/constants/inline-filter-items.js'

import { mapGetters } from 'vuex'
import { Helper } from '@/mixin/helper'
import { formatIndexDate } from '@/helpers/tzDate'

export default {
  page: {
    title: 'Pelacakan Sementara',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    McGrapqlTable,
    // McInlineFilter,
    McButton,
    ModalContactForm,
    ModalShareActions,
  },
  mixins: [Helper, MixPanel, fields],
  data() {
    return {
      baseUrl: window.location.origin,
      selectedItem: {},
      activeFilters: {},
      isSubmitContact: false,
      tableKey: 1,
    }
  },
  computed: {
    ...mapGetters({
      hasAccess: 'identity/hasAccess',
    }),

    title() {
      return `${this.$t('menuitems.trackingTemp.text')}`
    },

    inlineFilterItems() {
      return inlineFilterItems(this)
    },

    trackingTemporaryListApiClient() {
      return {
        get: async (args) => {
          const { orderBy, ...otherFilter } = args

          const processedOrderBy = orderBy ? JSON.parse(orderBy[0]) : { created_on: 'desc' }
          const filter = {
            ...otherFilter,
            orderBy: JSON.stringify(processedOrderBy),
          }

          if (this.activeFilters.status?.length > 0) {
            filter.status = this.activeFilters?.status[0]
          }

          const res = await this.$apollo.query({
            query: TRACKING_TEMPORARY_LIST,
            fetchPolicy: 'no-cache',
            variables: {
              filter,
            },
          })
          const temporaryLiveViews =
            res.data.temporaryLiveViewsPaginated.temporaryLiveViewsPaginated

          if (temporaryLiveViews.data == null) {
            return { data: [], pagination: { page: 1, show: 10 } }
          }

          return temporaryLiveViews
        },
        // TODO: change the API and add back feature hasSelectAll when on the backend there is API bulkDelete for tracking temporary, currently there is only delete for each id
        delete: async (id) => {
          const res = await this.$apollo.mutate({
            mutation: DELETE_TRACKING_TEMPORARY,
            variables: {
              input: {
                temporaryLvId: Number(id),
              },
            },
          })

          return res.data.deleteTemporaryLiveView.isSuccessful
        },
      }
    },

    customHandlers() {
      return {
        handleClickRow: this.handleClickRow,
        handleDisabledRow: this.handleDisabledRow,
        ...(this.hasAccess(['temporary_live_views:create']) && { handleAdd: this.handleAdd }),
      }
    },

    modalShareTitle() {
      return `${this.$t('trackingTemp.share')} ${this.selectedItem.name}`
    },

    selectedItemLink() {
      const token = this.selectedItem?.shortKey
        ? `shToken=${this.selectedItem.shortKey}`
        : `token=${this.selectedItem?.accessToken}`

      return `${this.baseUrl}/fleet/live-track/${this.selectedItem?.temporaryLvId}?${token}`
    },
  },
  methods: {
    formatIndexDate,

    handleClickRow(item) {
      if (!this.hasAccess(['temporary_live_views:update'])) return
      this.$router.push({
        name: 'Tracking Temporary Update',
        params: { id: item.temporaryLvId },
      })
    },

    handleAdd() {
      this.track('Pelacakan Sementara Add Clicked')

      this.$router.push({ name: 'Tracking Temporary Add' })
    },

    handleDisabledRow(item) {
      return Boolean(item.customerContract?.uuid)
    },

    handleChangeActiveFilters(filters) {
      filters.forEach((filter) => {
        this.$set(this.activeFilters, filter.key, filter.values)
      })
      
      this.tableKey += 1
    },

    handleOpenShareModal(item) {
      this.track('Pelacakan Sementara Share Clicked')

      this.selectedItem = { ...item }

      if (item.customerContract?.uuid) {
        this.$bvModal.show('modal-share-temp-tracking')
        return
      }

      this.$bvModal.show('modal-contact-form')
    },

    handleCancelModalCreateContact() {
      this.selectedItem = {}
    },

    async handleAddContact(data) {
      this.isSubmitContact = true

      const contact = { ...data }
      if (data.location) {
        contact.location = { ...data.location }
      }

      delete contact.contactId
      delete contact.createdBy
      delete contact.createdOn

      const input = {
        contact,
        temporaryLiveViewId: this.selectedItem.temporaryLvId,
      }

      this.$apollo
        .mutate({
          mutation: UPSERT_CONTACT_LOCATION_TEMPORARY,
          variables: { input },
        })
        .then((response) => {
          if (response.data.upsertContactLocationToTempLiveView.isSuccessful) {
            this.$mcToast.success('Berhasil menambahkan ke daftar kontak!')
            this.$bvModal.hide('modal-contact-form')
          } else {
            this.$refs['modal-contact-form'].SetFormErrors(
              response.data.upsertContactLocationToTempLiveView
            )

            this.$mcToast.error(response.data.upsertContactLocationToTempLiveView.message)
          }
        })
        .finally(() => {
          this.isSubmitContact = false
        })
    },
  },
}
</script>
